import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface UserProfile {
  walletAddress: string;
  name: string;
  email: string;
  bio?: string;
  profileImage?: string;
}

export const userAPI = {
  // Get user profile
  getProfile: async (walletAddress: string) => {
    const response = await api.get(`/users/profile/${walletAddress}`);
    return response.data;
  },

  // Check if profile exists
  checkProfile: async (walletAddress: string) => {
    const response = await api.get(`/users/check/${walletAddress}`);
    return response.data;
  },

  // Create or update profile
  createOrUpdateProfile: async (profileData: UserProfile & { signature?: string; message?: string }) => {
    const response = await api.post('/users/profile', profileData);
    return response.data;
  },
};

export default api;
